import { Controller } from '@hotwired/stimulus'
import { Calendar } from 'vanilla-calendar-pro'
import { DateTime } from 'luxon'

// Connects to data-controller="date-picker"
export default class extends Controller {
  static values = {
    disablePast: { type: Boolean, default: false }
  }

  connect () {
    if (this.hiddenInput) {
      return
    }

    const hiddenInput = document.createElement('input')
    hiddenInput.type = 'hidden'
    hiddenInput.name = this.element.name
    hiddenInput.value = this.element.value
    hiddenInput.setAttribute('data-date-picker-target', 'hiddenInput')

    this.element.parentElement.appendChild(hiddenInput)
    this.hiddenInput = hiddenInput

    const label = document.querySelector(`label[for="${this.element.id}"]`)

    if (label) {
      this.element.dataset.label = label.textContent.toString().trim().replace('*', '')
    }

    this.element.name = `orig_${hiddenInput.name}`
    this.element.id = `orig_${this.element.id}`

    if (this.element.value && this.element.value.trim() !== '') {
      this.#setDate(this.element.value)
    }

    const calendarOptions = {
      inputMode: true,
      positionToInput: 'auto',
      firstWeekday: 0,
      onChangeToInput: (self) => {
        if (!self.context.inputElement) return
        if (self.context.selectedDates[0]) {
          this.#setDate(self.context.selectedDates[0])
          self.hide()
        } else {
          this.#setDate(null)
        }
      }
    }

    if (this.disablePastValue) {
      calendarOptions.displayDateMin = 'today'
    }

    this.calendar = new Calendar(this.element, calendarOptions)

    this.calendar.init()

    this.element.setAttribute('readonly', 'readonly')
    this.element.classList.add('form-input--date')
    this.element.setAttribute('placeholder', 'MM/DD/YYYY')
  }

  disconnect () {
    this.calendar.destroy()
    this.element.removeAttribute('readonly')
    this.element.classList.remove('form-input--date')
    this.element.removeAttribute('placeholder')
  }

  #setDate (dateStr) {
    const date = DateTime.fromISO(dateStr)

    this.element.value = date.toLocaleString()
    this.hiddenInput.value = dateStr

    this.element.dispatchEvent(new Event('input'))
  }
}
